// extracted by mini-css-extract-plugin
export default {"dataTable":"styles_dataTable__cA0jO"};